import React from 'react';
import { useSelector } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import './side-panel__footer.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
}

export const SidePanelFooter = (props: Props) => {
    const isHeadless = useSelector(lessonViewSelectors.getIsHeadless);

    const { children } = props;

    if (isHeadless) {
        return null;
    }

    return <div className="side-panel__footer">{children}</div>;
};
